/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: ANil
 */

/******** Reducers ********/

const initialState = {
    url:'/assets/img/logo.png'
  };
  
  export default function reducer(state = initialState, action) {
    switch (action.type) {
      case 'Logo':
        return {logo:'/assets/img/logo.png'}
  
      default:
    return state
    }
  }
  